import { Component } from "@angular/core"
import { RouterLink } from "@angular/router"

import { Button } from "primeng/button"

@Component({
  selector: "app-critical-error-page",
  imports: [Button, RouterLink],
  templateUrl: "./critical-error.page.html",
})
export class CriticalErrorPage {
}
